import React from 'react';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
import './Banner.css';

// import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
// import "swiper/css";
// import "swiper/css/pagination";
import useBanner from '../../../../hooks/useBanner';
import { url } from '../../../../App';

// import required modules
// import { Autoplay, Pagination } from "swiper";

const Banner = () => {

    const { bannerItems } = useBanner();

    return (

        <>
            <div className="row gx-0">
                <div className="col-12 col-md-12">
                    <Slider autoplay={3000} className="slider">
                        {bannerItems?.map((item, index) => (
                            <div
                                key={index}
                                className="sliderContent"
                            >
                                <img src={`${url}${item?.image}`} alt="banner-item" className="bannerimg-opt" />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </>
    );
};

export default Banner;